import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'I already bought a workout pack. Why would I need this?',
  a: 'That pack is exactly the symptom. You bought a library — more options to choose from. Bootcamp Ready sells you the decision: one session per day, already assigned to a date, with the swaps and scripts to run it. Most coaches who own a big bundle still program every Sunday.'
}, {
  q: 'My classes are different. Isn’t a calendar too rigid?',
  a: 'Volume 04, the Adaptation Matrix, exists for that: small studio or rainy park, missing gear, 30+ people solo, knee, back and shoulder regressions. Bonus 02, the Exercise Swap Matrix, lets you replace any movement by pattern without redesigning the class.'
}, {
  q: 'What equipment do I need?',
  a: 'Sessions are built around kettlebells, dumbbells and bands, and every one has zero-equipment alternatives. If all you have is a park and a timer, you can still run the calendar.'
}, {
  q: 'Does it work with mixed-level groups?',
  a: 'Yes. Every session has regressions and progressions, and Bonus 04, the Client Level Decoder, shows you how to coach beginners, regulars and advanced clients inside the same class — one workout, three versions.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs laid out for printing, with large type you can read from a clipboard outdoors. Most coaches print the week and keep it on a clipboard; the checklists also come in a phone-friendly version.'
}, {
  q: 'Is this a certification or medical advice?',
  a: 'No. Bootcamp Ready is a programming resource for qualified coaches. It does not replace your certification, first-aid training or client screening, and you remain responsible for adapting each session to the people in front of you.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-white text-ink" data-id="element-82" data-mp="1ppmc2wze0kbt">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-83" data-mp="1kqrw02st19ve">
        <div className="text-center" data-id="element-84" data-mp="1krb12ixcw3s0">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-85" data-mp="1fs8a22e7ny31">Before you buy</p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-86" data-mp="2dg8losp1icnx">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-87" data-mp="23hj1gt9o8g4i">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-88" data-mp="1zew6wklm8h3m" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-89" data-mp="s35hhzi1gktr">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-90" data-mp="38mpoo6lm3vz6" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-91" data-mp="3ielxocp8l6i6" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-92" data-mp="3ncdn902esgj7">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}